import { SignupRootState } from '../types';

export const selectSignupData = (state: SignupRootState) => state.signup.data;
export const selectSignupError = (state: SignupRootState) => state.signup.error;
export const selectSignupIsLoading = (state: SignupRootState) => state.signup.isLoading;
export const selectSignupFields = (state: SignupRootState) => state.signup.fields;
export const selectSignupFieldsLoading = (state: SignupRootState) => state.signup.fieldsLoading;
export const selectSignupFieldsError = (state: SignupRootState) => state.signup.fieldsError;
